export enum GoogleMerchantSettingsEndpoint {
  ROOT = '/google-merchant-config',
}

export const getGoogleMerchantSettingsEndpoints = ({ channelId }: { channelId: string | number }) => ({
  GET_MERCHANT_SETTINGS: `${GoogleMerchantSettingsEndpoint.ROOT}/${channelId}`,
  UPDATE_MERCHANT_SETTINGS: `${GoogleMerchantSettingsEndpoint.ROOT}/${channelId}`,
});

export interface IGoogleMerchantSettings {
  id: string;
  channelId: number;
  enabled: boolean;
  accountId: string | null;
  dataSource: string | null;
  defaultCategoryId: string | null;
  language: string;
  feedLabel: string | null;
  currency: string;
  dryRun: boolean;
  sendReportEmail: boolean;
  createdAt: string;
  updatedAt: string;
}

// ============== DTO ==============

export interface IGetGoogleMerchantSettingsDTO {
  channelId: number;
}

export interface IUpdateGoogleMerchantSettingsDTO {
  channelId: number;
  enabled?: boolean;
  accountId?: string;
  dataSource?: string;
  defaultCategoryId?: string;
  language?: string;
  feedLabel?: string;
  currency?: string;
  country?: string;
  dryRun?: boolean;
  sendReportEmail?: boolean;
}

// ============== Response ==============

export type IGetGoogleMerchantSettingsResponse = IGoogleMerchantSettings | null;

export interface IUpdateGoogleMerchantSettingsResponse extends IGoogleMerchantSettings {}
